import React from 'react';
import PropTypes from 'prop-types';
import { VaCheckbox } from '@department-of-veterans-affairs/component-library/dist/react-bindings';

export default function CompareCheckbox({
  institution,
  compareChecked,
  handleCompareUpdate,
  cityState,
  label = 'Compare',
  checkboxDescription,
}) {
  const name = `${institution} ${cityState}`;
  return (
    <div className="vads-u-padding--0 vads-u-margin-top--neg2 vads-u-margin-bottom--0p5">
      <VaCheckbox
        className="vads-u-margin-top--4"
        id={name}
        name={name}
        label={label}
        checkboxDescription={checkboxDescription}
        checked={compareChecked}
        onVaChange={handleCompareUpdate}
        aria-describedby={name}
        data-testid={name}
      />
    </div>
  );
}
CompareCheckbox.propTypes = {
  compareChecked: PropTypes.bool.isRequired,
  handleCompareUpdate: PropTypes.func.isRequired,
  institution: PropTypes.string.isRequired,
  checkboxDescription: PropTypes.string,
  cityState: PropTypes.string,
  label: PropTypes.string,
};
